import Vue from 'vue'
import Router from 'vue-router'
import { reportEvent } from '@g/utils/aosAnalytics'
import { kkrenHomeUrl } from '@g/site/kkrenNavigation'

// Container
// import Login from '@/views/_layout/Login'
// import Register from '@/views/_layout/Register'

// Modules
// import MchDashboard from '@/views/_merchant/Dashboard'
import { dgorderRoutes } from './dgorder'
import { tbdgRoutes } from './tbdg'
import { webTestRoutes } from './webTest'
import { walletRoutes } from './wallet'
import { aliRoutes } from './ali'
import { schoolRoutes } from './school'
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/mchDashboard',
      name: 'Home',
      component: () => import('@/views/_layout/Merchant'),
      children: [
        {
          path: 'mchDashboard',
          name: 'MchDashboard',
          redirect: '/parcelV2',
          // component: MchDashboard
        },
        {
          path: 'address',
          name: 'Address',
          component: () => import('@/views/_merchant/address/Index')
        },
        {
          path: 'parcel',
          name: 'Parcel',
          // redirect: '/parcelV2',
          // component: Parcel
          component: () => import('@/views/_merchant/parcel/IndexV2'),
          meta: {
            noAuth: true
          }
        },
        {
          path: 'parcelV2',
          name: 'ParcelV2',
          // component: () => import('@/views/_merchant/parcel/IndexV2')
          redirect: '/parcel',
        },
        {
          path: 'order',
          name: 'Order',
          component: () => import('@/views/_merchant/order/Index')
        },
        {
          path: 'comment/list',
          name: 'CommentList',
          component: () => import('@/views/_merchant/comment/List')
        },
        {
          path: 'post/list',
          name: 'PostList',
          component: () => import('@/views/_merchant/post/List')
        },
        {
          path: '/coin/index',
          name: 'CoinIndex',
          component: () => import('@/views/coin/Index')
        },
        {
          path: '/coin/rule',
          name: 'CoinRule',
          component: () => import('@/views/coin/Rule')
        },
        {
          path: '/coupon/index',
          name: 'CouponIndex',
          component: () => import('@/views/coupon/Index')
        },
        {
          path: '/introduc/se',
          name: 'IntroducSe',
          component: () => import('@/views/_merchant/introduc/Se'),
          meta: {
            noAuth: true,
            title: '海快'
          }
        },
        {
          path: '/introduc/sea',
          name: 'IntroducSea',
          component: () => import('@/views/_merchant/introduc/Sea'),
          meta: {
            noAuth: true,
            title: '海運'
          }
        },
        {
          path: '/introduc/sea6',
          name: 'IntroducSea6',
          component: () => import('@/views/_merchant/introduc/Sea6'),
          meta: {
            noAuth: true,
            title: '海運'
          }
        },
        {
          path: '/introduc/air',
          name: 'IntroducAir',
          component: () => import('@/views/_merchant/introduc/Air'),
          meta: {
            noAuth: true,
            title: '空運'
          }
        },
        {
          path: '/finance/proof',
          name: 'FinanceProof',
          component: () => import('@/views/finance/Proof.vue'),
          meta: {
            title: '進口憑證'
          }
        },
        ...dgorderRoutes,
        ...tbdgRoutes,
        ...walletRoutes,
        ...schoolRoutes,
      ]
    },
    {
      path: '/noLoginHome',
      name: 'NoLoginHome',
      redirect: '/login',
      // component: () => import('@/views/home/NoLoginHome'),
      // meta: {
      //   noAuth: true
      // }
    },
    {
      path: '/user/line-login',
      name: 'UserLineLogin',
      component: () => import('@/views/user/LineLogin'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('@/views/home/About'),
      meta: {
        noAuth: true
      }
    },
    ...aliRoutes,
    {
      path: '/home/calendar',
      name: 'HomeCalendar',
      component: () => import('@/views/home/calendar/Calendar.vue'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/home/address',
      name: 'HomeAddress',
      component: () => import('@/views/home/address/Address.vue'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/suspendPost',
      name: 'SuspendPost',
      component: () => import('@/views/home/suspendPost/Index.vue'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/suspendPost/detail',
      name: 'SuspendPostDetail',
      component: () => import('@/views/home/suspendPost/Detail.vue'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/post/detail/:poid',
      name: 'PostDetail',
      component: () => import('@/views/home/post/Detail.vue'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/downloadApp',
      name: 'DownloadApp',
      component: () => import('@/views/home/DownloadApp'),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      // redirect: '/noLoginHome',
      // component: Login
      beforeEnter: to => window.location.replace(kkrenHomeUrl(to)),
      meta: {
        noAuth: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      beforeEnter: to => window.location.replace(kkrenHomeUrl(to)),
      meta: { noAuth: true },
    },
    ...webTestRoutes,
  ]
})

// 统一处理地址栏参数
router.beforeEach((to, from, next) => {
  let accessToken

  // 通过地址栏传递了 accessToken
  if (to.query.accessToken && to.query.accessToken.length > 64) {
    accessToken = to.query.accessToken
    localStorage.setItem('accessToken', accessToken)
  } else {
    accessToken = localStorage.getItem('accessToken')
  }

  // 是否登录
  const isLogined = accessToken && accessToken.length > 64

  if (to.meta.noAuth) {
    // 不需要登录的页面
    next()
  } else {
    if (!isLogined) sessionStorage.setItem('redirect', to.fullPath)
    next(isLogined ? true : '/noLoginHome')
  }
  if (window.top) {
    window.top.postMessage({
      action: 'jyChangeUrl',
      locationHash: window.location.hash
    }, '*')
  }
})

router.afterEach((to, form) => {
  window.gtag && window.gtag('event', 'page_view', {
    page_title: to.meta.title || to.name,
    page_location: to.path,
  })
  reportEvent('page_view', {
    pageTitle: to.meta.title || to.name,
    // page_location: to.path,
  })
})

export default router
